<template>
  <span class="p_badge label label-info js-tooltip" data-title="Personale"> P </span>
</template>
<script>
export default {
  name: 'pLabel',
};
</script>
